import { BillingStrategy, createResolvedBillingStrategy, type BillingStrategyQuery } from '@ctct/domain-layer';
import { PaymentStrategy, type PaymentStrategyQuery } from '@ctct/state-server-layer';

const pendingBillingStrategy: BillingStrategyQuery = { data: null, isPending: true };
const stripeBillingStrategy = createResolvedBillingStrategy(BillingStrategy.Stripe);
const inHouseBillingStrategy = createResolvedBillingStrategy(BillingStrategy.InHouse);

const pendingPaymentStrategy: PaymentStrategyQuery = { data: null, isPending: true };
const stripePaymentStrategy: PaymentStrategyQuery = { data: PaymentStrategy.Stripe, isPending: false };
const paasPaymentStrategy: PaymentStrategyQuery = { data: PaymentStrategy.Paas, isPending: false };

export const resolveBillingStrategyQuery = (billingStrategy: BillingStrategyQuery): BillingStrategyQuery => {
  if (billingStrategy.isPending) {
    return pendingBillingStrategy;
  }

  return billingStrategy.data === BillingStrategy.Stripe ? stripeBillingStrategy : inHouseBillingStrategy;
};

export const resolvePaymentStrategyQuery = (paymentStrategy: PaymentStrategyQuery): PaymentStrategyQuery => {
  if (paymentStrategy.isPending) {
    return pendingPaymentStrategy;
  }

  return paymentStrategy.data === PaymentStrategy.Stripe ? stripePaymentStrategy : paasPaymentStrategy;
};
